import type { CSSProperties, ReactElement } from "react";

/** One line-icon set: 24 px grid, 2.5 px stroke, round caps (doc: "Icons"). */
const P: Record<string, ReactElement> = {
  build: <><path d="M12 2.5 22 7.5 12 12.5 2 7.5Z" /><path d="M2 7.5v9.5l10 5 10-5V7.5" /><path d="M12 12.5V22" /></>,
  furnish: <><path d="M4 9h16l-3-6H7Z" /><path d="M12 9v11" /><path d="M7 21h10" /></>,
  staff: <><circle cx="8" cy="7" r="3.5" /><path d="M2 20v-2a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5v2" /><circle cx="17" cy="8" r="3" /><path d="M17 14h1a4 4 0 0 1 4 4v2" /></>,
  projects: <><rect x="3" y="7" width="18" height="14" rx="2" /><path d="M2 3h20v4H2Z" /><path d="M10 12h4" /></>,
  market: <><path d="M3 18 9 11l4 4 8-9" /><path d="M15 6h6v6" /><path d="M2 22h20" /></>,
  layers: <><path d="M12 2 23 8 12 14 1 8Z" /><path d="M1 14l11 6 11-6" /></>,
  coin: <><circle cx="12" cy="12" r="9" /><path d="M12 7v10" /><path d="M15 9.5c0-1.4-1.3-2.5-3-2.5s-3 1-3 2.3c0 3.2 6 1.8 6 5 0 1.4-1.3 2.7-3 2.7s-3-1.1-3-2.5" /></>,
  fans: <><circle cx="12" cy="6" r="3.5" /><path d="M4 21v-3a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v3" /></>,
  research: <><path d="M9 3h6" /><path d="M10 3v6L4.5 19a1.6 1.6 0 0 0 1.4 2.3h12.2a1.6 1.6 0 0 0 1.4-2.3L14 9V3" /><path d="M7 15h10" /></>,
  heart: <path d="M12 20s-8-5-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 9c0 6-8 11-8 11Z" />,
  pause: <><path d="M9 5v14" /><path d="M15 5v14" /></>,
  play: <path d="M7 4v16l13-8Z" />,
  ff: <><path d="M3 5v14l9-7Z" /><path d="M12 5v14l9-7Z" /></>,
  fff: <><path d="M1 6v12l7-6Z" /><path d="M8 6v12l7-6Z" /><path d="M15 6v12l7-6Z" /></>,
  close: <><path d="M5 5l14 14" /><path d="M19 5 5 19" /></>,
  chevron: <path d="m9 5 7 7-7 7" />,
  back: <path d="m15 5-7 7 7 7" />,
  replay: <><path d="M20 12a8 8 0 1 1-2.3-5.6" /><path d="M20 4v5h-5" /></>,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v6" /><path d="M12 7.5v.5" /></>,
  check: <path d="m4 12 5 5L20 6" />,
  warn: <><path d="M12 3 2 21h20Z" /><path d="M12 10v5" /><path d="M12 18v.5" /></>,
  lock: <><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></>,
  plus: <><path d="M12 5v14" /><path d="M5 12h14" /></>,
  minus: <path d="M5 12h14" />,
  print: <><path d="M6 9V3h12v6" /><rect x="3" y="9" width="18" height="8" rx="2" /><path d="M7 14h10v7H7Z" /></>,
  star: <path d="m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9Z" />,
  trend: <><path d="M3 17 9 11l4 4 8-8" /><path d="M14 7h7v7" /></>,
  box: <><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5Z" /><path d="m3 7.5 9 4.5 9-4.5" /><path d="M12 12v9" /></>,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18" /><path d="M8 3v4" /><path d="M16 3v4" /></>,
  gear: <><circle cx="12" cy="12" r="3.5" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9 7 7M17 17l2.1 2.1M4.9 19.1 7 17M17 7l2.1-2.1" /></>,
  save: <><path d="M5 3h11l5 5v13H5Z" /><path d="M8 3v6h8V3" /><path d="M8 21v-7h8v7" /></>,
  table: <><path d="M3 9h18" /><path d="M5 9l-2 10" /><path d="M19 9l2 10" /><path d="M8 5h8" /></>,
  doc: <><path d="M6 2h9l5 5v15H6Z" /><path d="M14 2v6h6" /><path d="M9 13h7M9 17h5" /></>,
  trophy: <><path d="M7 4h10v5a5 5 0 0 1-10 0Z" /><path d="M7 6H3a4 4 0 0 0 4 4" /><path d="M17 6h4a4 4 0 0 1-4 4" /><path d="M12 14v4" /><path d="M8 21h8" /></>,
  pet: <><circle cx="6" cy="9" r="2" /><circle cx="18" cy="9" r="2" /><circle cx="9.5" cy="5" r="2" /><circle cx="14.5" cy="5" r="2" /><path d="M12 11c-4 0-6 4-6 6.5S8 21 12 19.5c4 1.5 6 0 6-2S16 11 12 11Z" /></>,
  plant: <><path d="M12 21V11" /><path d="M12 11C12 6 8 4 4 4c0 4 3 7 8 7Z" /><path d="M12 13c0-4 3-6 7-6 0 4-3 6-7 6Z" /><path d="M8 21h8" /></>,
  bell: <><path d="M6 10a6 6 0 0 1 12 0c0 6 2 7 2 7H4s2-1 2-7" /><path d="M10 20a2 2 0 0 0 4 0" /></>,
  zoom: <><circle cx="10.5" cy="10.5" r="6.5" /><path d="m15.5 15.5 5 5" /><path d="M10.5 7.5v6M7.5 10.5h6" /></>,
  money: <><rect x="2" y="6" width="20" height="12" rx="2" /><circle cx="12" cy="12" r="2.5" /><path d="M6 9v.5M18 14.5v.5" /></>,
  menu: <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>,
  feedback: <><path d="M4 4h16v12H8l-4 4Z" /><path d="M8 9h8M8 12h5" /></>,
  dice: <><rect x="3" y="3" width="18" height="18" rx="4" /><circle cx="8" cy="8" r="1.2" /><circle cx="12" cy="12" r="1.2" /><circle cx="16" cy="16" r="1.2" /></>,
};

export type IconName = keyof typeof P;

export function Icon({ name, size = 24, color = "currentColor", stroke = 2.5, style, title }: { name: IconName | string; size?: number; color?: string; stroke?: number; style?: CSSProperties; title?: string }) {
  const filled = name === "play" || name === "ff" || name === "fff";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? color : "none"}
      stroke={filled ? "none" : color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flex: "none", ...style }}
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
    >
      {title ? <title>{title}</title> : null}
      {P[name] ?? P.info}
    </svg>
  );
}

/** The logo: a coral die with diagonal pips, next to the wordmark. */
export function Logo({ size = 36 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 36 36" aria-label="Box & Dice" role="img">
      <rect x="0" y="0" width="36" height="36" rx="9" fill="#E85848" />
      {[[9, 9], [18, 18], [27, 27]].map(([x, y]) => <circle key={x} cx={x} cy={y} r="3.5" fill="#FAF6EE" />)}
    </svg>
  );
}

export const ICONS = Object.keys(P);
